import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import 'bootstrap/dist/css/bootstrap.min.css'
import reportWebVitals from './reportWebVitals';
import { Route, BrowserRouter, Routes } from 'react-router-dom';
import UploadFile from './components/UploadFile'

function Router() {
  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<UploadFile />} />
      </Routes>
    </BrowserRouter>
  );
}

const rootEl = document.getElementById('root');
if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <React.StrictMode>
      <Router />
    </React.StrictMode>
  );
}

reportWebVitals();